import * as React from "react";
import { Progress as ProgressHybrid } from "./ProgressHybrid";
import type { TypeProgressProps } from "./ProgressTypes";

/**
 * Progress component. Automatically routes between the Tailwind implementation
 * (preferred) and the styled-components implementation (for consumers using
 * system props or styled() extension).
 */
const Progress = (props: TypeProgressProps) => <ProgressHybrid {...props} />;

Progress.displayName = "Progress";

export { Progress };
